import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { BillingPaymentsProvider } from '../../providers/billing-payments/billing-payments';
import { LoginProvider } from  '../../providers/login/login';
import { ToastProvider } from '../../providers/toast/toast';
import { UtilService } from '../../services/util';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-payment-detail',
  templateUrl: 'payment-detail.html',
})
export class PaymentDetailPage {

	paymentData: any;
  profileData = {};

  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    private translate: TranslateService,
  	private bpProvider: BillingPaymentsProvider,
  	private toast: ToastProvider,
    private loginProvider: LoginProvider,
    private loadingCtrl: LoadingController,
    private util: UtilService) {

    let loader = this.loadingCtrl.create({});

    loader.present().then(() => {
      bpProvider.getPaymentDetail(this.navParams.get("id")).then(val => {
        if(val.status == "success"){
          this.paymentData = val.data[0];
          if(this.paymentData.data){
            this.paymentData.data = JSON.parse(this.paymentData.data);
            if(this.paymentData.data && this.paymentData.data.meter_service){
              this.paymentData.meter_service = this.paymentData.data.meter_service;
            }
          }
        }else{
          toast.presentToast(val.message);
        }
        loader.dismiss();
      });
      loginProvider.getUserDetails().then(val => {
        this.profileData = val;
      });
    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PaymentDetailPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/payment-detail/payment-detail.ts